'use strict';
var parent = require('../../actual/object/entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/entries.js
// module id = 362
// module chunks = 0